import React from 'react'
import './style/mainAnalysisView.scss'

import TabsSection from './TabsSection'
import DateRangeSelector from './DateRangeSelector'
import StatsCards from './StatsCards'
import KeywordTags from './KeywordTags'
import DataTable from './DataTable'

const MainAnalysisView = () => {
  return (
    <div className="main-analysis">
        <TabsSection />
      <h2 className="section-title">Top Card</h2>
        <StatsCards />
        <KeywordTags />
        <DataTable />
    </div>
  )
}

export default MainAnalysisView